














import Vue from 'vue';
import Component from 'vue-class-component';
import { Action } from 'vuex-class';
import DialogStopServer from './components/dialogStopServer/index.vue';

@Component({
  components: {
    DialogStopServer
  }
})
export default class App extends Vue {
  @Action getUserInfo: () => {};
  get isKeepAlive() {
    if(!this.$route) return false;
    return this.$route.meta ? this.$route.meta.keepAlive : false;
  }
  stopServerDisable: string = 'false';
  clickStopServer() {
    this.stopServerDisable = 'false';
    localStorage.setItem('stopServerDisable', 'true');
  }
  checkStopServerTime() {
    // var startTime: number = new Date('2021/04/03 00:00:01').getTime(); // 测试时间
    var startTime: number = new Date('2021/05/03 00:00:01').getTime();
    var currentTime: number = new Date().getTime();
    var endTime: number = new Date('2021/05/03 21:59:59').getTime();
    if (currentTime < endTime && currentTime > startTime) {
      try {
        const value = localStorage.getItem('stopServerDisable');
        if (value) {
          this.stopServerDisable = 'false';
        } else {
          this.stopServerDisable = 'true';
        }
      } catch (e) {
        console.log('e');
      }
    } else {
      this.stopServerDisable = 'false';
    }
  }
  mounted() {
    this.getUserInfo();
    this.checkStopServerTime()
  }
}
